import React, { FC } from 'react'
import Modal from '@material-ui/core/Modal'
import { CrossIcon } from 'uiKit/icons/CrossIcon'
import {
  ButtonsWrap,
  CancelButton,
  CloseButton,
  ConfirmButton,
  Container,
  Description,
  Divider,
  HeaderWrap,
  Title,
} from './ResendInviteModal.styles'

interface Props {
  open: boolean
  onClose: () => void
  onResend: () => void
}

export const ResendInviteModal: FC<Props> = ({ open, onClose, onResend }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Container>
        <HeaderWrap>
          <Title>Resend Invitation?</Title>
          <CloseButton onClick={onClose}>
            <CrossIcon color={'var(--color-spun-pearl-grey)'} />
          </CloseButton>
        </HeaderWrap>
        <Description>
          {'Are you sure you want to resend the invitation email? A new invitation link will be sent to the user\'s email address and will remain valid for 7 days.'}
        </Description>
        <Divider />
        <ButtonsWrap>
          <CancelButton onClick={onClose}>No, Cancel</CancelButton>
          <ConfirmButton onClick={onResend}>Yes, Resend</ConfirmButton>
        </ButtonsWrap>
      </Container>
    </Modal>
  )
}
